import { render } from "./MembersComponent.vue?vue&type=template&id=04bdc9cc"
import script from "./MembersComponent.vue?vue&type=script&lang=js"
export * from "./MembersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__